<template>
  <div
    class="flow-root overflow-x-auto inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
  >
    <table class="min-w-full table-fixed divide-y divide-gray-300">
    <thead>
        <tr v-if="tableheader && tableheader.length">
        <th
            v-for="(d,index) in tableheader"
            :key="index"
            scope="col"
            class="pr-3 py-3.5 text-left text-sm font-semibold text-gray-900"
            :class="d.sort ? 'cursor-pointer' : ''"
            @click="d.sort ? tableFunctions.activateSortHandler(d) : ''"
        >
            {{ d.name }}
            <i v-if="d.sort && d.sort === 'default'" class="fa fa-sort" aria-hidden="true"></i>
            <i v-else-if="d.sort && d.sort === 'desc'" class="fa fa-sort-desc" aria-hidden="true"></i>
            <i v-else-if="d.sort && d.sort === 'asc'" class="fa fa-sort-asc" aria-hidden="true"></i>
        </th>
        </tr>
    </thead>
    <tbody
        class="divide-y divide-gray-200 bg-white"
        v-if="tableData && tableData.length"
    >
        <tr v-for="d in tableData" :key="d.id">
            <td
            class="whitespace-nowrap py-4 pr-3 text-sm font-medium text-blue-700 capitalize"
            >
            <span
              v-if="d.is_trainer"
              class="bg-red-600 px-1.5 py-0.5 text-sm text-white rounded-sm mx-1"
            >T</span>
            <span
              v-else-if="tableFlags.activeUserType && tableFlags.activeUserType !== 1"
              class="px-1.5 py-0.5 text-sm text-white rounded-sm mx-1"
            >&ensp;</span>
            <router-link
            class="hover:underline"
            :to="{
            name: tableFlags.activeUserType && tableFlags.activeUserType === 2 ? 'AdminTrainersProfileAbout' : 'AdminUsersProfileAbout',
            params: { id: d.id },
            }"
            target="_blank"
            >
            {{ d.f_name }}
            </router-link>
            </td>
            <td
            class="whitespace-nowrap py-4 pr-3 text-sm font-medium text-gray-900 capitalize"
            >
            {{ d.l_name }}
            </td>
            <td
            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
            >
            {{ d.account_created_time }}
            </td>
            <td
            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
            >
            {{ handleLastLogin(d.last_login) }}
            </td>
            <td
            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
            >
            {{ d.email }}
            </td>
            <td
            v-if="tableFlags.activeUserType && tableFlags.activeUserType !== 2"
            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
            >
              {{ d.amount_spent ? `$ ${d.amount_spent}` : "$ 0" }}
            </td>
            <td
            v-else
            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
            >
              {{ d.amount_earned ? `$ ${d.amount_earned}` : "$ 0" }}
            </td>
            <td
            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
            >
            {{ d.total_booked_sessions || "0" }}
            </td>
            <td
            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
            >
            {{ d.total_booked_courses || "0" }}
            </td>
            <td
            class="whitespace-nowrap px-3 py-4 text-sm text-gray-dark"
            >
            {{ d.is_active_boolean ? 'In-Active' : 'Active' }}&nbsp;
            <label class="relative inline-flex items-center cursor-pointer">
            <input type="checkbox" v-model="d.is_active_boolean" class="sr-only peer" @click="tableFunctions.toggleUserStatusHandler(d)">
            <div class="w-11 h-6 bg-gray-400 rounded-full peer 
            dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white
            after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white
            after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 
            after:transition-all dark:border-gray-600 peer-checked:bg-red-600"></div>
            </label>
            </td>
            <td
            class="whitespace-nowrap px-3 py-4 flex items-center text-sm text-gray-dark"
            v-if="tableFlags.activeUserType && tableFlags.activeUserType !== 2"
            >
            {{ d.time_to_join_boolean ? 'Unlimited' : 'Default' }}&nbsp;
            <label class="relative inline-flex items-center cursor-pointer">
            <input type="checkbox" v-model="d.time_to_join_boolean" class="sr-only peer" @click="tableFunctions.toggleUserTimeHandler(d)">
            <div class="w-11 h-6 bg-gray-400 rounded-full peer 
            dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white
            after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white
            after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 
            after:transition-all dark:border-gray-600 peer-checked:bg-red-600"></div>
            </label>
            </td>
            <td
              v-else
              class="whitespace-nowrap px-3 py-4 flex items-center text-sm text-gray-dark"
            >
              {{ d.platform_fee_exception_boolean ? 'No Fee' : 'Active' }}&nbsp;
              <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" v-model="d.platform_fee_exception_boolean" class="sr-only peer" @click="tableFunctions.toggleTrainerFeesHandler(d)">
                <div class="w-11 h-6 bg-gray-400 rounded-full peer 
                dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white
                after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white
                  after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 
                  after:transition-all dark:border-gray-600 peer-checked:bg-red-600"></div>
              </label>
            </td>
        </tr>
    </tbody>
    </table>
    <div class="flex justify-between">
      <span class="text-sm text-gray-dark">Total: {{ tablePaginateInfo.total }}</span>
      <PaginationComponent
        v-if="tableData.length"
        :currentPage="tablePaginateInfo.current_page"
        :handlePageChange="tableFunctions.handlePageChange"
        :totalPages="tablePaginateInfo.last_page"
      />
      <span>&emsp;</span>
    </div>
  </div>
</template>
<script>
import { PaginationComponent } from "@/components/t-components";
export default {
  name: 'AdmintableLayout',
  data () {
    return {

    }
  },
  components: {
    PaginationComponent
  },
  props: [
    'tableheader',
    'tableData',
    'tableFunctions',
    'tableFlags',
    'tablePaginateInfo'
  ]
}
</script>